import React from 'react';
import {
    Button,
    Card,
    Divider,
    Dropdown,
    Form,
    Input,
    Menu,
    notification,
    Select,
    Space,
    Typography,
    Upload
} from "antd";

import {DownOutlined, LoadingOutlined, PlusOutlined} from '@ant-design/icons';
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";

import ApiService from "../../../services/ApiService"
import {API_BASE_URL, ASSET_BASE_URL} from "../../../configs/AppConfig";
import ModalLink from "../../../modals/ModalLink";
import CerfaButton from "./CerfaButton";
import {LANGS} from "../../../lang/";
import {getLanguage} from "../../../components/permissions/functions";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;

export default class FormAsso extends React.Component {

    constructor(props) {
        super(props);
    }

    state = {
        loadingInit: true,
        loading: false,
        defaultData: {},
        image: null
    };

    componentDidMount() {
        this.init()
    }

    async init() {
        this.setState({loadingInit: true})

        var res = await ApiService.get("/infos/general")
        console.log(res)

        if (res.success) {
            this.setState({loadingInit: false, defaultData: res.data, image: res.data.logo}, () => {
                setTimeout(() => {
                    if (!Array.isArray(this.form.getFieldValue("languages"))) {
                        this.form.setFieldValue("languages", [])
                    }
                    this.form.setFieldValue("image", this.state.image)
                }, 500)
            })
        }
    }

    async onSubmit(data) {
        this.setState({loading: true})

        data.image = this.state.image
        console.log(data)

        var res = await ApiService.post("/infos/general/edit", data)
        console.log(res)

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Modification réussie` : t`Ajout réussi`
            })
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l’ajout`
            })
        }

        this.setState({loading: false})
    }

    render() {

        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined/> : <PlusOutlined/>}
                <div className="ant-upload-text"><Trans>Logo</Trans></div>
                <span className="ant-upload-text"><Trans>png / jpg (872×872)</Trans></span>
            </div>
        );

        return (
            <Card loading={this.state.loadingInit}>

                <div style={{display: "flex", justifyContent: "space-between", marginBottom: 30}}>
                    <CerfaButton/>

                    <Dropdown overlay={
                        <Menu
                            items={[
                                {
                                    label: (
                                        <a href="#" onClick={() => this.modalLink.setOptions({multiDevise:true}).getLink("PAIEMENT", {
                                            type: "GENERAL",
                                            typeId: null,
                                        })}>
                                            <Text><Trans>Lien Caisse Principale</Trans></Text>
                                        </a>
                                    ),
                                    key: '0',
                                }
                            ]}
                        />
                    } trigger={['click']}>
                        <a onClick={(e) => e.preventDefault()}>
                            <Space>
                                <Trans>Liens</Trans>
                                <DownOutlined/>
                            </Space>
                        </a>
                    </Dropdown>
                </div>

                <Form
                    initialValues={this.state.defaultData}
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                >

                    <Form.Item
                        label={t`Logo`}
                        name="image"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                        shouldUpdate
                    >
                        <Upload
                            name="image"
                            multiple={false}
                            accept="image/*"
                            listType={this.state.image ? null : "picture-card"}
                            showUploadList={false}
                            onChange={({file}) => {
                                if (file.response && file.status == "done") {
                                    this.setState({image: file.response})
                                    this.form.setFieldValue("image", file.response)
                                }
                            }}
                            headers={{authorization: localStorage.getItem("AUTH_TOKEN")}}
                            action={API_BASE_URL + "/upload/image"}
                            style={{border: "none"}}
                        >
                            {this.state.image ? (
                                <div style={{
                                    cursor: "pointer",
                                    backgroundColor: "#FFF",
                                    borderRadius: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: 5,
                                    overflow: "hidden"
                                }}>
                                    <img src={ASSET_BASE_URL + "/" + this.state.image}
                                         style={{width: 100, height: 100, objectFit: "contain"}} onError={(e) => {
                                        const path = API_BASE_URL + "/upload/tmp/" + this.state.image
                                        if (e.target.src != path) {
                                            e.target.src = path
                                        }
                                    }}
                                    />
                                </div>
                            ) : uploadButton}
                        </Upload>
                    </Form.Item>

                    <Form.Item
                        label={t`Nom`}
                        name="name"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Input placeholder={t`Nom`}/>
                    </Form.Item>

                    <Form.Item
                        label={t`Nom Court`}
                        name="shortName"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Input placeholder={t`Nom Court`}/>
                    </Form.Item>

                    <Form.Item
                        label={t`Adresse`}
                        name="adresse"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Input placeholder={t`Adresse`}/>
                    </Form.Item>

                    <Form.Item
                        label={t`Code Postal`}
                        name="postal"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Input placeholder={t`Code Postal`}/>
                    </Form.Item>

                    <Form.Item
                        label={t`Ville`}
                        name="ville"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Input placeholder={t`Ville`}/>
                    </Form.Item>

                    <Divider/>

                    <Form.Item
                        label={t`Opinion Rabbinique ( Zman Halah'ique )`}
                        name="zmanimShitat"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Select placeholder={t`Opinion Rabbinique`}>
                            <Option value="DEFAULT">{t`Default (Shoulhan arrou'h)`}</Option>
                            <Option value="HABBAD.ORG">{t`Chabad.org`}</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={t`Langues Supplémentaires`}
                        name="languages"
                    >
                        <Select mode="multiple" placeholder={t`Langues Supplémentaires`}>
                            {LANGS.filter(i => i.value !== getLanguage()).map(i => {
                                return (
                                    <Select.Option value={i.value}>{i.label}</Select.Option>
                                )
                            })}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>

                </Form>

                <ModalLink getRef={(ref) => this.modalLink = ref}/>
            </Card>
        )
    }
}
